import { Documents } from '../components/Documents';
import { useSettingsContext } from '../context/SettingsContext';

export const DocumentsRoute = () => {
  const { setConfirmationModalOpen, setTotalUnprocessedDocs, detailsChanged, isReprocessing } = useSettingsContext();

  return (
    <Documents
      openModal={setConfirmationModalOpen}
      setTotalUnprocessedDocs={setTotalUnprocessedDocs}
      detailsChanged={detailsChanged}
      isReprocessing={isReprocessing}
    />
  );
};
